import { filterStartsWith } from '@/utils/shared'
import { contains, dateLess, dateMore, equals, makeFilter, notEquals } from '@/utils/dynamic'
import { STATUS_IDS } from '@/services/statuses'
export default ({ sourceConditions }) => ({
  id: 'stock',
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  store: {
    get: {
      url: 'Stocks/GetAllDynamic',
      selected: [
        'id', 'statusID', 'partID', 'tagDate', 'tagInfoCompany.name as tagBy', 'externalLocationCompanyID',
        'externalLocationCompany.name as externalLocationCompanyName', 'stockLocation.title as stockLocationTitle',
        'part.partNumber as partNumber', 'partSN', 'part.partDescription as partDescription',
        'entryDate', 'baxpoNumber', 'qty', 'condition.title as conditionTitle',
        'release.title as releaseTitle', 'status.title as statusTitle',
        'statusID !=2 as isStatusAvailable', 'part.aircraft.aircraftModel as aircraftModel', 'shelfLifeLimit', 'sellPrice',
        'sellExchCurrency.title as currencyTitle'
      ].join(',')
    },
    create: {
      url: 'Stocks/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'Stocks/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'Stocks/Delete/${data.id}',
      modal: {
        msgDataKey: 'partSN'
      }
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        permission: 'isAllowToEditStocks'
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-number')}",
      field: 'partNumber',
      sortable: {
        custom: 'part.partNumber'
      },
      editor: {
        type: 'select',
        remote: true,
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        permission: '${data.id === 1 || data.id === 2}',
        required: true,
        data: {
          url: 'Parts/GetAllDynamic',
          selected: 'id,partDescription,partNumber as title'
        }
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-SN')}",
      field: 'partSN',
      editor: {
        type: 'string',
        required: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('condition')}",
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      },
      editor: {
        type: 'select',
        field: 'conditionID',
        data: 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('location')}",
      field: 'stockLocationTitle',
      sortable: {
        custom: 'stockLocation.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('external-location-company')}",
      field: 'externalLocationCompanyName',
      sortable: {
        custom: 'externalLocationCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('tag-date')}",
      field: 'tagDate',
      template: 'date',
      editor: {
        type: 'date'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('tag-by')}",
      field: 'tagBy',
      sortable: {
        custom: 'tagInfoCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('stock-part-aircraft')}",
      field: 'aircraftModel',
      sortable: {
        custom: 'part.aircraft.aircraftModel'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('qty')}",
      field: 'qty',
      editor: {
        type: 'number',
        required: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('part-description')}",
      field: 'partDescription',
      sortable: {
        custom: 'part.partDescription'
      },
      classes: 'column-size-small'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('baxpo-number')}",
      field: 'baxpoNumber',
      editor: {
        type: 'string'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('release')}",
      field: 'releaseTitle',
      sortable: {
        custom: 'release.title'
      },
      editor: {
        type: 'select',
        field: 'releaseID',
        data: 'Releases/GetAllDynamic?select=id,title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('entry-date')}",
      field: 'entryDate',
      template: 'date',
      editor: {
        type: 'date'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('status-title')}",
      field: 'statusTitle',
      sortable: {
        custom: 'status.title'
      },
      editor: {
        type: 'select',
        field: 'statusID',
        data: 'Statuses/GetAllDynamic?select=id,title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('is-status-available')}",
      field: 'isStatusAvailable',
      template: 'boolean'
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          valueTemplate: ({ value }) =>
            makeFilter(['partSN', 'part.partDescription', 'salesRemark', 'part.partNumber', 'stockRemark',
              'stockTechnicalRemark', 'status.title', 'ownerCompany.name', 'tagInfoCompany.name', 'traceabilityCompany.name'], value, contains),
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}",
          styles: {
            minWidth: '17rem'
          },
          classes: 'stocks-part-filter-field'
        }
      },
      {
        type: 'selectautocomplete',
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('part')}",
        options: {
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber,partDescription,remark'
          },
          searchAllColumns: true,
          columns: [
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-number')}",
              value: 'partNumber',
              originField: 'partNumber',
              type: 'custom',
              customFilter: filterStartsWith
            },
            {
              // eslint-disable-next-line no-template-curly-in-string
              title: "${root.L10n('part-description')}",
              value: 'partDescription',
              originField: 'partDescription',
              type: 'custom',
              customFilter: filterStartsWith
            }
          ],
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'selectautocomplete',
        field: 'externalLocationCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('external-location-company')}",
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'name.StartsWith("${data.search}")',
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name'
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '20rem'
          },
          classes: 'stocks-part-filter-field'
        }
      },
      {
        type: 'select',
        field: 'conditionID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('condition')}",
        options: {
          dataSource: sourceConditions,
          valueTemplate: (data) => {
            return data.value
              ? `${data.field} == ${data.value === 'NULL' ? null : data.value}`
              : null
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        field: 'stockLocationID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('location')}",
        options: {
          dataSource: 'StockLocations/GetAllDynamic?select=id,title',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        field: 'statusID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('status')}",
        options: {
          dataSource: [
            {
              id: STATUS_IDS.available,
              title: 'Available'
            },
            {
              id: STATUS_IDS.sold,
              title: 'Sold'
            },
            {
              id: STATUS_IDS.reserved,
              title: 'Reserved'
            },
            {
              id: STATUS_IDS.quarantine,
              title: 'Quarantine'
            }
          ],
          valueTemplate: (data) => {
            switch (data.value) {
              case STATUS_IDS.available: {
                return makeFilter(data.field, STATUS_IDS.sold, notEquals)
              }
              default: {
                return makeFilter(data.field, data.value, equals)
              }
            }
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          value: 1,
          clearable: false
        }
      },
      {
        type: 'select',
        place: 'inner',
        field: 'salesRemarkID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('sales-remark')}",
        options: {
          dataSource: 'StockSalesRemarks/GetAllDynamic?select=id,remark as title&orderBy=remark asc',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'select',
        place: 'inner',
        field: 'part.aircraftID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('stock-part-aircraft')}",
        options: {
          dataSource: 'Aircrafts/GetAllDynamic?select=id,aircraftModel as title&orderBy=aircraftModel asc',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      },
      {
        type: 'datemultiple',
        place: 'inner',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("tag-date")}',
        field: 'tagDate',
        options: {
          tabs: [0, 2, 3, 4]
        }
      },
      {
        type: 'datemultiple',
        place: 'inner',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("entry-date")}',
        field: 'entryDate',
        options: {
          tabs: [0, 2, 3, 4]
        }
      },
      {
        type: 'datemultiple',
        place: 'inner',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("sell-exch-price-date")}',
        field: 'sellExchPriceDate',
        options: {
          tabs: [0, 2, 3, 4]
        }
      },
      {
        type: 'select',
        field: 'shelfLifeLimit',
        place: 'inner',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('shelf-life-limit')}",
        options: {
          dataSource: [
            {
              id: 1,
              title: 'past'
            },
            {
              id: 2,
              title: 'feature'
            }
          ],
          valueTemplate: (data) => {
            if (data.value === 1) {
              return makeFilter(data.field, new Date(), dateMore)
            } else if (data.value === 2) {
              return makeFilter(data.field, new Date(), dateLess)
            } else {
              return undefined
            }
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          clearable: false
        }
      },
      {
        type: 'select',
        place: 'inner',
        field: 'warehouseLocationID',
        // eslint-disable-next-line no-template-curly-in-string
        label: "${root.L10n('warehouse-location')}",
        options: {
          dataSource: 'WarehouseLocations/GetAllDynamic?select=id,title',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}"
        }
      }
    ]
  },
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'edit'
        }
      ]
    }
  },
  permission: {
    edit: 'isAllowToEditStocks'
  }
})
